import { createContext, useContext } from 'react'

export const GalleryPreloadContext = createContext(null)
export const useGalleryPreload = () => useContext(GalleryPreloadContext)
